angular.module('tf.controllers')

    .controller('subscriptionDepController', ['$scope', 'HttpService','NotificationService','Session', '$state', 'userInfo',
        function ($scope, HttpService, NotificationService, Session, $state, userInfo) {
            $scope.data = {};
            $scope.step = 1;
            $scope.plan = "Basic";
            $scope.preiod = "Basic";
            $scope.pricing={
                basic       : {
                    m       : 700,
                    y       : 7500
                },
                pro         : {
                    m       : 1500,
                    y       : 15000
                },
                payg        : 1.5
            };

            // $scope.isSubscribed = false;
            // if(Session.user){
            //     $scope.isSubscribed = Session.user.isSubscribed();
            // }else{
            //     Session.whenReady().then(function(){
            //         $scope.isSubscribed = Session.user.isSubscribed();
            //     });
            // }

            $scope.processingPayment=false;

            $scope.currentSlide = function(){
                return "slide-"+$scope.step;
            };

            $scope.back = function(){
                $scope.step--;
            };

            $scope.buy = function (plan) {
                $scope.plan = plan;
                $scope.step=2;
                // //TODO in case we already subscribed, just add the option to upgrade
                // if($scope.isSubscribed && $scope.plan === 'Pro'){
                //     NotificationService.confirm('Plan Subscription', 'We are going to upgrade your plan, please confirm', function(){
                //         switchPlans();
                //     });
                // }else{
                //     $scope.step=2;
                // }
            };

            // function switchPlans(){
            //     $scope.data.plan = $scope.plan.toLowerCase();
            //     $scope.data.period = $scope.period.toLowerCase();
            //     HttpService.post("plan/switch", $scope.data)
            //         .then(function (res) {
            //                 Session.farm = res.data;
            //                 $scope.processingPayment = false;
            //                 NotificationService.confirm('Plan Subscription', 'Plan Upgrade Successful', function(){
            //                     window.location.replace("/");
            //                 }, true, 'success');
            //
            //             },
            //             function (err) {
            //                 $scope.processingPayment = false;
            //             }
            //         );
            // }

            $scope.subscribe = function () {
                $scope.processingPayment = true;
                $scope.data.plan = $scope.plan.toLowerCase();
                $scope.data.period = $scope.period.toLowerCase();
                HttpService.post("plan/upgrade", $scope.data)
                    .then(function (res) {
                        // console.log(res);
                        Session.farm = res.data;
                        $scope.processingPayment = false;
                        NotificationService.confirm('Plan Subscription', 'Plan Upgrade Successful', function(){
                            window.location.replace("/");
                        }, true, 'success');
                        // $scope.step = 3;

                    },
                    function (err) {
                        $scope.processingPayment = false;
                        // console.log(err);
                    }
                );
            };

            $scope.shouldShowPrices = function () {
                return true;
                // return userInfo && userInfo.country && userInfo.country.code === 'US';
            };

            // var ccForm = $('#cc-form');

            // var card = new Card({
            //     form: document.getElementById('cc-form'),
            //     container: document.getElementById('card-wrapper'),
            //
            //     placeholders: {
            //         number: '•••• •••• •••• ••••',
            //         name: 'Full Name',
            //         expiry: '••/••',
            //         cvc: '•••'
            //     },
            //
            //     masks: {
            //         cardNumber: '•' // optional - mask card number
            //     }
            // });
        }]);